// 例（target）：contentfulInformation.title
// target で指定したキーに対応する値が truthy な場合に children を返す
function CustomTemplateIf({
  data: pageData,
  children,
  // component props
  target = undefined,
  targetOr = [],
}) {
  return getTargetValue(target, pageData) ||
    targetOr.some((target) => getTargetValue(target, pageData))
    ? children
    : null
}

const getTargetValue = (target, pageData) =>
  target?.split('.').reduce((object, key) => object?.[key], pageData)

export { CustomTemplateIf }
